"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _actions = require("settings-ui-sdk/Blogs/actions");

var _actions2 = require("settings-ui-sdk/Channels/actions");

var _actions3 = require("settings-ui-sdk/Domains/actions");

var _actions4 = require("settings-ui-sdk/Users/actions");

var _actions5 = require("settings-ui-sdk/UserSettings/actions");

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _constants = require("settings-ui-sdk/UserSettings/constants");

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var BaseBlogsSettingsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BaseBlogsSettingsContainer, _Component);

  function BaseBlogsSettingsContainer() {
    (0, _classCallCheck2.default)(this, BaseBlogsSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BaseBlogsSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BaseBlogsSettingsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadBlogs();
      this.props.loadPayload();
      this.props.loadChannels();
      this.props.loadBlogDomains();
      this.props.fetchUserSetting(_constants.BLOG_SETTINGS_NAMESPACE, _constants.USER_SETTINGS_UID, this.props.userId);
      import('./general/GeneralSettings'
      /* webpackChunkName: "chunk-website-blog" */
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fetchBlogsRequestStatus = _this$props.fetchBlogsRequestStatus;
      return _react.default.createElement(_LoadingHOC.default, {
        unrecoverableFailure: true,
        requestStatuses: [fetchBlogsRequestStatus],
        successMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "BLOG_SETTINGS_LOADED"
        }),
        failureMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "BLOG_SETTINGS_LOADED_FAILURE"
        })
      }, _react.default.createElement("div", {
        "data-test-id": "blog-settings-page",
        className: "blog-settings-page p-bottom-10"
      }, children));
    }
  }]);
  return BaseBlogsSettingsContainer;
}(_react.Component);

BaseBlogsSettingsContainer.propTypes = {
  loadBlogs: _react.PropTypes.func.isRequired,
  loadChannels: _react.PropTypes.func.isRequired,
  loadBlogDomains: _react.PropTypes.func.isRequired,
  loadPayload: _react.PropTypes.func.isRequired,
  fetchUserSetting: _react.PropTypes.func.isRequired,
  fetchBlogsRequestStatus: _react.PropTypes.string.isRequired,
  userId: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    fetchBlogsRequestStatus: (0, _selectors.getFetchBlogsRequestStatus)(state),
    userId: (0, _selectors2.getUserId)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  loadBlogs: _actions.loadBlogs,
  loadChannels: _actions2.loadChannels,
  loadBlogDomains: _actions3.loadBlogDomains,
  loadPayload: _actions4.loadPayload,
  fetchUserSetting: _actions5.fetchUserSetting
})(BaseBlogsSettingsContainer);

exports.default = _default;
module.exports = exports.default;